export default __webpack_public_path__ + "static/media/4B.9f863da2.png";